import useFormReply from '../../customHooks/useFormReply'
import styles from "./replayFormComponent.module.css"
interface IReplayFormComponent {
  parentId: number | null;
  setDisplayNewReply: Function
}
const ReplayFormComponent = ({ parentId, setDisplayNewReply }: IReplayFormComponent) => {
  const { email, reply, setEmail, setReply, handleForm, } = useFormReply(parentId, setDisplayNewReply);
  return (
    <div className={`${styles.formContainer}`}>
      <form onSubmit={(e) => handleForm(e)}>
        <input value={email} onChange={(e) => setEmail(e.target.value)} type="text" placeholder='Email' />
        <textarea value={reply} onChange={(e) => setReply(e.target.value)} placeholder='Make your reply'></textarea>
        <button>add reply</button>
        <button onClick={() => setDisplayNewReply(false)}>Cancel</button>
      </form>
    </div>
  )
}

export default ReplayFormComponent